<h1 mat-dialog-title>Datos completos de la ayuda</h1>
<div mat-dialog-content>
    <div class="contenedor3 mb-4" *ngIf="ayuda">
        <div class="row" style="margin-left: 15px">
            <div class="col">
                <label>Tipo de solicitante</label>
                <div class="borde m-0">
                <p>
                    <b>{{ ayuda.tipoSolicitante | null }}</b>
                </p>
                </div>
            </div>
            <div class="col">
                <label>Tipo de adquisición</label>
                <div class="borde m-0">
                <p>
                    <b>{{ ayuda.tipoAdquisicion | null }}</b>
                </p>
                </div>
            </div>
            <div class="col">
                <label>Ayuda adicional</label>
                <div class="borde m-0">
                <p>
                    <b>{{ ayuda.ayudaAdicional | null }}</b>
                </p>
                </div>
            </div>
            <div class="col">
                <label>Importe ayuda Minimis</label>
                <div class="borde m-0">
                <p>
                    <b>{{ ayuda.importeAyudaMinimis | null }}</b>
                </p>
                </div>
            </div>
        </div>
        
        <div class="row" style="margin-left: 15px">
            <div class="col">
                <label>Achatarra vehículo</label>
                <div class="borde m-0"
                *ngIf="ayuda.achatarraVehiculo == true; else noAchatarra">
                <p>
                    <b>Sí</b>
                </p>
                </div>
            </div>
            <ng-template #noAchatarra>
                    <div class="borde m-0">
                    <p>
                        <b>No</b>
                    </p>
                    </div>
            </ng-template>

            <div class="col">
                <label>Matrícula achatarrado</label>
                <div class="borde m-0">
                <p>
                    <b>{{ ayuda.matriculaAchatarrado | null }}</b>
                </p>
                </div>
            </div>
            <div class="col">
                <label>Marca achatarrado</label>
                <div class="borde m-0">
                <p>
                    <b>{{ ayuda.marcaAchatarrado | null }}</b>
                </p>
                </div>
            </div>
            <div class="col">
                <label>Modelo achatarrado</label>
                <div class="borde m-0">
                <p>
                    <b>{{ ayuda.modeloAchatarrado | null }}</b>
                </p>
                </div>
            </div>
            <div class="col">
                <label>Fecha matriculación achatarrado</label>
                <div class="borde m-0" *ngIf="ayuda.fechaMatriculacionAchatarrado != null; else fechaNull">
                <p>
                    <b>{{ ayuda.fechaMatriculacionAchatarrado | date : "dd/MM/yyyy"   }}</b>
                </p>
                </div>
            </div>
            <ng-template #fechaNull>
                <div class="borde m-0">
                    <p>
                        <b>-</b>
                    </p>
                </div>
            </ng-template>
        </div>
        
        <div class="row" style="margin-left: 15px">
            <div class="col">
                <label>Marca y modelo eléctrico</label>
                <div class="borde m-0">
                <p>
                    <b>{{ ayuda.marcaModeloElectrico | null }}</b>
                </p>
                </div>
            </div>

            <div class="col">
                <label>Es vehículo demo</label>
                <div class="borde m-0" *ngIf="ayuda.esDemo == true; else nodemo">
                <p>
                    <b>Sí</b>
                </p>
                </div>
            </div>
            <ng-template #nodemo>
                <div class="borde m-0">
                <p>
                    <b>No</b>
                </p>
                </div>
            </ng-template>
            <div class="col">
                <label>Es vehículo nuevo</label>
                <div class="borde m-0" *ngIf="ayuda.vehiculoNuevo == true; else usado">
                <p>
                    <b>Sí</b>
                </p>
                </div>
            </div>
            <ng-template #usado>
                <div class="borde m-0">
                <p>
                    <b>No</b>
                </p>
                </div>
            </ng-template>
            <div class="col">
                <label>Autonomía eléctrico Km</label>
                <div class="borde m-0">
                <p>
                    <b>{{ ayuda.autonomiaElectrica | null }}</b>
                </p>
                </div>
            </div>
            <div class="col">
                <label>Potencia Kwh</label>
                <div class="borde m-0">
                <p>
                    <b>{{ ayuda.potenciaKwh | null }}</b>
                </p>
                </div>
            </div>
            <div class="col">
                <label>Facturar a</label>
                <div class="borde m-0">
                <p>
                    <b>{{ ayuda.facturarA | null }}</b>
                </p>
                </div>
            </div>
        </div>
        
    </div>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Cerrar</button>
</div>
